import { Injectable } from '@angular/core';
import { IHasIdAndName } from '../interfaces/has-id-and-name.interface';
import { IListItem } from '../interfaces/ilist-item.interface';
import { AlertDialogComponent, AlertDialogModel } from '../dialogs/alert/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ItemTypeEnum } from '../enums/item-type.enum';
import { FormInstance } from '../models/site-content/form-instance.model';

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {

    private copiedItems: IListItem[] = [];
    private cutItems: IListItem[] = [];
    private allCopiedAreReferences: boolean;

    constructor(public dialog: MatDialog) { }

    public copyItemsToClipboard(items: IListItem[]) {
        let types = new Set(items.map(x => x.getType()));
        let refs = items.filter(x => { return x.getType() == ItemTypeEnum.FORM_INSTANCE }).filter((x: FormInstance) => { return x.isReference });
        this.allCopiedAreReferences = refs.length == items.length;

        if (types.size > 1) {
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: new AlertDialogModel("Item type mismatch", `You can only copy items of the same type, folders or forms.`)
            });

        }
        this.copiedItems = items;
    }

    public cutItemsToClipboard(items: IListItem[]) {
        let types = new Set(items.map(x => x.getType()));
        if (types.size > 1) {
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: new AlertDialogModel("Item type mismatch", `You can only copy items of the same type, folders or forms.`)
            });

        }
        this.cutItems = items;
    }

    public get CopiedItems(): IListItem[] {
        return this.copiedItems;
    }

    public get CutItems(): IListItem[] {
        return this.cutItems;
    }

    public getCopiedItemsOfType(types): any[] {
        if (!this.copiedItems) {
            return [];
        } else {
            return this.copiedItems.filter(x => { return types.includes(x.getType()) });
        }
    }

    public getCutItemsOfType(types): any[] {
        if (!this.CutItems) {
            return [];
        } else {
            return this.cutItems.filter(x => { return types.includes(x.getType()) });
        }
    }

    public hasCopiedItemsOfType(type: string[]) {
        return this.getCopiedItemsOfType(type).length > 0;
    }

    public hasCutItemsOfType(type: string[]) {
        return this.getCutItemsOfType(type).length > 0;
    }

    public get AllCopiedAreReferences(): boolean {
        return this.allCopiedAreReferences;
    }
}
